// extracted by mini-css-extract-plugin
export default {"colorDepartment":"selectDepartments_colorDepartment__1-L8Q"};